// extracted by mini-css-extract-plugin
export default {"suits":"style_suits__fTha8","title":"style_title__d9+yr"};